// The following imports are required. See https://stackoverflow.com/questions/53558916/babel-7-referenceerror-regeneratorruntime-is-not-defined#54490329
import "core-js/stable";
import "regenerator-runtime/runtime";

import { createApolloClient } from "vue-cli-plugin-apollo/graphql-client";
import { customLink } from "./customLink";
import {
  AUTH_TOKEN_LOCAL_STORAGE_KEY,
  getBearerToken,
} from "../../auth/tokens";

const computeDefaultOptions = () => ({
  wsEndpoint: null,
  tokenName: AUTH_TOKEN_LOCAL_STORAGE_KEY,
  persisting: false, // Enable Automatic Query persisting with Apollo Engine
  websocketsOnly: false,
  ssr: false, // Is it being rendered on the server?
  link: customLink,
  getAuth: () => getBearerToken(),
});

const { apolloClient, wsClient } = createApolloClient(computeDefaultOptions());

apolloClient.wsClient = wsClient;

export { apolloClient };
